import { isPast, isToday } from 'date-fns';

// PPD 신규/legacy/POD/오릭스 - BE에서 내려주는 cancel_available (픽업 위치 현지시간 기준)으로 판단
// 온트라 - 픽업시간 도래 여부로 판단
export const isReservationCancelDisabled = ({
  cancelEnabled,
  pickupDate,
}: {
  cancelEnabled?: boolean;
  pickupDate?: Date;
}) => {
  if (cancelEnabled !== undefined) return !cancelEnabled;
  if (pickupDate && (isToday(pickupDate) || isPast(pickupDate))) return true;
  return false;
};
